export const showLoadCount = (
  totalRecords: number,
  currentPage: number,
  pageSize: number
) => {
  let remainingCount = totalRecords - pageSize * (currentPage + 1);
  if (remainingCount >= pageSize) return pageSize;
  if (remainingCount < pageSize && remainingCount > 0) return remainingCount;
  return null;
};